import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Paper,
  TextField,
  MenuItem,
  Button,
  Chip,
  CircularProgress,
  IconButton
} from "@mui/material";

import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { DataGrid } from "@mui/x-data-grid";

import { useEffect, useState } from "react";

import axios from "axios";

 const columns = [
    {
        field: "razorpay_order_id",
        headerName: "Order ID",
        width: 230,
    },
    {
        field: "amount",
        headerName: "Amount",
        width: 130,
        renderCell: (params) => `₹${(params.value || 0)}`,
    },
    {
        field: "method",
        headerName: "Method",
        width: 180,
    },
    {
        field: "customer_name",
        headerName: "Name",
        width: 230,
    },
    {
        field: "phone",
        headerName: "Contact",
        width: 160,
    },
    {
        field: "payment_status",
        headerName: "Status",
        width: 150,
        renderCell: ({ value }) => {

    const colors = {
        created: "default",
        authorized: "warning",
        captured: "success",
        refunded: "info",
        failed: "error",
    };

    return (
        <Chip
            size="small"
            label={value || "-"}
            color={colors[value] || "default"}
        />
    );
}
    },
    {
        field: "created_at",
        headerName: "Created",
        width: 190,
         renderCell: (params) => {
          const timestamp = params.value?.$date;

          return timestamp
            ? new Date(timestamp).toLocaleString()
            : "-";
        },
    },
    {
      field: "service_type",
      headerName: "Service Type",
      width: 160
}
];


const PaymentDashboard=()=>{
const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    const [payments, setPayments] = useState([]);

    const [summary, setSummary] = useState({});

    const [search, setSearch] = useState("");

    const [status, setStatus] = useState("");

    const [service, setService] = useState("");

    const [method, setMethod] = useState("");

    const [page, setPage] = useState(0);

    const [pageSize, setPageSize] = useState(10);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [refundStatus, setRefundStatus] = useState("");
    const [serviceType, setServiceType] = useState("");
    const [totalRows, setTotalRows] = useState(0);
    const now = new Date();

      
useEffect(() => {
  fetchPayments();
}, [
  page,
    pageSize,
    paymentStatus,
    refundStatus,
    serviceType,
    fromDate,
    toDate,method
]);
useEffect(() => {
    let ws;

    const connect = () => {
        ws = new WebSocket(`${process.env.REACT_APP_ALERT_TONE}/ws/payment-status`);

        ws.onopen = () => {
            console.log("WS Connected");
            ws.send("connected");
        };

        ws.onmessage = (event) => {
            const data = JSON.parse(event.data);

            if (data.type === "payment_updated") {
                fetchPayments();
                fetchSummary();
            }
        };

        ws.onclose = () => {
            console.log("WS Closed. Reconnecting...");
            setTimeout(connect, 3000);
        };

        ws.onerror = () => {
            ws.close();
        };
    };

    connect();

    return () => {
        ws.close();
    };
}, []);
useEffect(() => {
  fetchSummary();
}, []);
const fetchPayments = async () => {
  try {
    setLoading(true);

    const { data } = await axios.get(
      `${process.env.REACT_APP_FAST_API}/payment/payment-transactions`,
      {
        params: {
    page: page + 1,
    page_size: pageSize,
    search: search || undefined,
    payment_status: paymentStatus || undefined,
    refund_status: refundStatus || undefined,
    service_type: serviceType || undefined,
    from_date: fromDate || undefined,
    to_date: toDate || undefined,
    method:method|| undefined,
}
      }
    );


    setTransactions(data.transactions);

        setTotalRows(data.total);


  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};
const fetchSummary = async () => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_FAST_API}/payment/transactions/summary`
    );

    setSummary(data);

  } catch (err) {
    console.error(err);
  }
};
const cards = [

{
title:"Revenue",
value:`₹${summary.revenue || 0}`,
color:"#2e7d32"
},

{
title:"Successful",
value:summary.captured || 0,
color:"#4caf50"
},

{
title:"Pending",
value:summary.pending || 0,
color:"#f9a825"
},

{
title:"Failed",
value:summary.failed || 0,
color:"#d32f2f"
},

{
title:"Refunded",
value:summary.refunds || 0,
color:"#1976d2"
},

{
title:"Transactions",
value:summary.total || 0,
color:"#6a1b9a"
}

];

    
return(
<Box sx={{ p: 1, bgcolor: "#f4f6f8", minHeight: "100vh",  ml: { md: '300px' }  }}>

<Typography
variant="h4"
fontWeight="bold"
mb={3}
>

Payment Dashboard

</Typography>

<Grid container spacing={2} mb={3}>

{
cards.map(card=>(

<Grid item xs={12} md={2} key={card.title}>

<Card>

<CardContent>

<Typography color="text.secondary">

{card.title}

</Typography>

<Typography
variant="h5"
fontWeight="bold"
sx={{
color:card.color
}}
>

{card.value}

</Typography>

</CardContent>

</Card>

</Grid>

))

}
</Grid>

<Paper
sx={{
p:2,
mb:2,
display:"flex",
gap:2,
flexWrap:"wrap"
}}
>

<TextField
label="Search"
value={search}
onChange={(e)=>setSearch(e.target.value)}
size="small"
/>

<TextField
select
label="Status"
size="small"
value={paymentStatus}
onChange={(e)=>{
    setPage(0);
    setPaymentStatus(e.target.value);
}}
sx={{width:170}}
>

<MenuItem value="">All</MenuItem>
<MenuItem value="created">Created</MenuItem>
<MenuItem value="authorized">Authorized</MenuItem>
<MenuItem value="captured">Captured</MenuItem>
<MenuItem value="failed">Failed</MenuItem>
<MenuItem value="refunded">Refunded</MenuItem>

</TextField>

<TextField
select
label="Service"
size="small"
value={serviceType}
onChange={(e)=>{
    setPage(0);
    setServiceType(e.target.value);
}}
sx={{width:170}}
>

<MenuItem value="">All</MenuItem>

<MenuItem value="medicine">Medicine</MenuItem>

<MenuItem value="diagnostic">Diagnostic</MenuItem>

<MenuItem value="nursing">Nursing</MenuItem>

</TextField>

<TextField
    select
    label="Method"
    size="small"
    value={method}
    onChange={(e)=>{
        setPage(0);
        setMethod(e.target.value);
    }}
    sx={{width:170}}
>

<MenuItem value="">All</MenuItem>

<MenuItem value="upi">UPI</MenuItem>

<MenuItem value="card">Card</MenuItem>

<MenuItem value="netbanking">Net Banking</MenuItem>

<MenuItem value="wallet">Wallet</MenuItem>

</TextField>

<Button
    variant="contained"
    onClick={() => {
        setPage(0);
        fetchPayments()
    }}
>
  Search
</Button>

<IconButton
    onClick={() => {

        setSearch("");
        setPaymentStatus("");
        setRefundStatus("");
        setServiceType("");
        setMethod("");
        setFromDate("");
        setToDate("");
        setPage(0);
        fetchPayments();

    }}
>
    <RefreshIcon />
</IconButton>

</Paper>
<Paper>

<DataGrid
    rows={transactions}
    columns={columns}
    loading={loading}
    getRowId={(row) => row.razorpay_order_id}

    paginationMode="server"

    rowCount={totalRows}

    pageSizeOptions={[10,20,50,100]}

    paginationModel={{
        page,
        pageSize
    }}

    onPaginationModelChange={(model)=>{
        setPage(model.page);
        setPageSize(model.pageSize);
    }}

    disableRowSelectionOnClick

    autoHeight
/>

</Paper>

</Box>
  )  
}
export default PaymentDashboard;